import React from 'react';
import * as S from './Field.style';

export default function Field({ label, name }) {

  return (
    <S.FieldCaption name={name}>{label}</S.FieldCaption>
  );
}
